// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"9414":"bf3b217b7955ee0e","9961":"4ecf317cf4f9a6ed"}[chunkId] + ".css";
};